/**
 * Constructs a CDN URL for text match data files.
 * When cdnPathPrefix is provided (from CTF's compactTextMatches), it is used directly.
 * Otherwise falls back to the legacy path.
 */
export function getTextMatchCdnUrl(
  inspectionId: string,
  ctfJobId: string,
  fileName: string,
  cdnPathPrefix?: string | null,
): string {
  const path = cdnPathPrefix ? `${cdnPathPrefix}/${fileName}` : `text-matches/${inspectionId}/${ctfJobId}/${fileName}`;
  const isAiDomain = window.location.hostname.endsWith('.ai');
  const cdnDomain = isAiDomain ? import.meta.env.VITE_VERIFY_CDN_AI_URL : import.meta.env.VITE_VERIFY_CDN_URL;

  if (window.location.hostname === 'localhost') {
    return `/cdn/${path}`;
  }

  if (!cdnDomain) {
    throw new Error('Environment variable VITE_VERIFY_CDN_URL is required but not defined.');
  }

  return `${cdnDomain}/${path}`;
}
